import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Link } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ChatInterface from './components/ChatInterface';
import SignupPage from './components/Onboarding';
import PrivacyPolicy from './components/PrivacyPolicy';
import CalendlyPage from './components/CalendlyPage';
import './App.css';
import StudentsPage from './components/StudentsPage';
import TeacherAssistant from './components/DemoPage';
import SchedulePage from './components/SchedulePage';

// Modified LandingPage wrapper to handle navigation
const LandingPageWrapper = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/signup');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <LandingPage 
      onGetStarted={handleGetStarted}
      onSignup={handleSignup}
    />
  );
};

// Signup/Onboarding page wrapper to handle navigation to Calendly
const SignupPageWrapper = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/schedule');
  };

  return (
    <SignupPage onGetStarted={handleGetStarted} />
  );
};

// Privacy Policy wrapper with signup navigation
const PrivacyPolicyWrapper = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <PrivacyPolicy 
      onNavigateHome={handleNavigation}
      onSignup={handleSignup}
    />
  );
};

// Calendly page wrapper
const CalendlyWrapper = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/');
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <CalendlyPage 
      onNavigateHome={handleNavigation}
      onSignup={handleSignup}
    />
  );
};

// NotFound component for 404 pages
const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-zinc-900 mb-4">Page Not Found</h1>
        <p className="text-zinc-600 mb-8">The page you're looking for doesn't exist.</p>
        <Link 
          to="/" 
          className="px-6 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

const DemoPageWrapper = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/');
  };

  return (
    <Routes>
      <Route 
        index 
        element={<TeacherAssistant onNavigateHome={handleNavigation} />} 
      />
      <Route 
        path="ai-assistant" 
        element={<TeacherAssistant onNavigateHome={handleNavigation} />} 
      />
      <Route 
        path="students" 
        element={<StudentsPage onNavigateHome={handleNavigation} />} 
      />
      <Route 
        path="schedule" 
        element={<SchedulePage onNavigateHome={handleNavigation} />} 
      />
    </Routes>
  );
};

// NotFound component remains the same...

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPageWrapper />} />
          <Route path="/signup" element={<SignupPageWrapper />} />
          <Route path="/chat" element={<ChatInterface />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyWrapper />} />
          <Route path="/schedule" element={<CalendlyWrapper />} />
          <Route path="/demo/*" element={<DemoPageWrapper />} />
          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;